export default __webpack_public_path__ + "static/media/nav-close-icon-black.6a49b43e.svg";